<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <!-- Title-->
    <div>
      <header-component
        :headerTitle="headerText"
        :router-link="{ name: 'Transfer' }"
        :router-link-text="'Choose Transferrable Items'"
        :return-condition="true"
        :component-name="'Transferrable Items'"
      />
    </div>

    <!-- search, filter, Action buttons -->
    <v-card class="v-card-100 mt-0">
      <v-card-title  class="action-style pa-4">
        <!-- Search fields -->
        <v-row class="m-0">
          <v-row>
            <v-col cols="8" sm="8">
              <v-text-field
                color="primary"
                prepend-inner-icon="mdi-magnify"
                v-model="search_tag"
                label="Search"
                hide-details
                style="max-width: 300px; margin-top: 10px;"
                variant="outlined"
                v-on:keyup.enter="loadData('tab_clicked')"
              ></v-text-field>
            </v-col>
          </v-row>
        <!-- Transfer button -->
        <v-card-actions>
          <v-btn
            color="primary"
            variant="flat"
            class="text-none"
            size="x-large"
            :disabled="selected.length == 0"
            @click="transferClicked">Transfer</v-btn>
            <v-btn class="ml-2 text-none" variant="flat" color="primary" @click="navigateToFileUpload" size="x-large">Upload</v-btn>
        </v-card-actions>

        <!-- Filter -->
        <v-expansion-panels class="custom-control_outlined ma-2" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 56px" >
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
      </v-card-title>
    </v-card>

    <!-- Data Table-->
    <v-layout column>
        <v-data-table hover
          :search="search"
          density="compact"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :items-per-page="pageSize"
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
        >
        <template #bottom></template>
        </v-data-table>
    </v-layout>

    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-2"
                />

    <!--Filter Popup-->
    <v-row justify="center">
      <v-dialog
        content-class="filter-data"
        v-model="filterPopUp"
        persistent
        max-width="624"
      >
        <v-card style="max-width: 100% !important" class="filter_ui">
          <v-card-actions>
            <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              label="Tag ID"
              v-model="tagId_search"
              variant="outlined"
              class="ma-2"
            ></v-text-field>
            <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              label="Article ID"
              v-model="articleId_search"
              variant="outlined"
              class="ma-2"
            ></v-text-field>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="outlined"
              color="primary"
              class="btn-cancel text-none"
              @click="filterPopUp = false"
              >Cancel</v-btn
            >
            <v-btn variant="flat" class="text-none" size="small" color="primary" @click="applyFilterFunc"
              >Apply Filter(S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Transfer Popup-->
    <v-row justify="center">
      <v-dialog v-model="transferPopup" persistent max-width="700">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Transfer Details</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="transferPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
           <v-row>
            <v-col cols="12" sm="6" lg="6">
            <v-autocomplete
              color="primary"
              prepend-inner-icon="mdi-magnify"
              label="Transfer Location"
              v-model="new_location"
              :items="locationList"
              item-title="name"
              item-value="id"
              variant="outlined"
              return-object
            ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="6">
            <v-text-field
              color="primary"
              label="Transfer reason"
              v-model="remarks"
              variant="outlined"
            ></v-text-field>
            </v-col>
           </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              size="large"
              variant="outlined"
              color="primary"
              class="cancel-color mb-3 text-none"
              @click="transferPopup = false"
              >Cancel</v-btn
            >
            <v-btn
              size="large"
              :color="!new_location || number > 0 ? '' : 'primary'"
              @click="transferSubmit"
              :disabled="!new_location || !remarks || number > 0"
              class="mb-3 text-none"
              variant="flat"
              >Submit</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Success Message-->
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>{{ message }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white" varaint="flat" class="mb-3 bg-blue" @click="loadData">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';

export default {
  components: {
    HeaderComponent,
  },
  data() {
    return {
      headerText: "Transfer",
      alert: false,
      alert_message: "",
      alert_type: "",
      search: "",
      selected: [],
      page: 1,
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      totalPages: 1,
      headers: [
        { title: "Tag ID", key: "tag_number", minWidth: "200px"  },
        { title: "Article ID", key: "sku_code", minWidth: "200px"  },
        { title: "Article Description", key: "item_description", minWidth: "250px" },
        { title: "Category", key: "category", minWidth: "200px"  },
        { title: "Item Sub-Location", key: "sub_location", minWidth: "250px"  },
        { title: "Item Location", key: "location", minWidth: "200px"  },
      ],
      loading: false,
      table_data: [],
      filterPopUp: false,
      articleId_search: "",
      tagId_search: "",
      transferPopup: false,
      new_location: "",
      remarks: "",
      number: 0,
      successPopup: false,
      message: "",
      location: "",
      disposition: "",
      status: "",
      locationList: [],
      dispo_type: "",
    };
  },
  async created() {
    this.location = this.$store.state.locationId;
    this.disposition = this.$store.state.disposition;
    this.status = this.$store.state.status;
    this.dispo_type = this.$store.state.dispo_type;
    this.loadData();
    this.fetchLocation();
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadData(tab_action) {
      if (tab_action != "tab_clicked") {
        this.search_tag = "";
      }
      this.loading = true;
      this.page = 1;
      this.successPopup = false;
      this.totalPages = 1;
      this.selected = [];
      this.fetchTableData();
    },
    fetchTableData() {
      const params = {
        search: this.search_tag,
        page: this.page,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get(
          "/api/v1/transfer_inventories?distribution_center_id=" +
            this.location +
            "&disposition=" +
            this.disposition +
            "&status=" +
            this.status +
            "&disposition_type=" +
            this.dispo_type,
          { params: params },
        )
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.inventories;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchTableData();
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchTableData();
    },
    filterListOfButtons() {
      this.filterPopUp = true;
      this.articleId_search = "";
      this.tagId_search = "";
    },
    transferClicked() {
      this.transferPopup = true;
      this.number = 0;
      this.new_location = null;
      this.remarks = "";
    },
    transferSubmit() {
      this.number++;
      const idsList = this.selected.map((x) => x.id);
      this.$httpSecured
        .post("/api/v1/transfer_inventories/download_transfer", {
          ids: idsList,
          receiving_location: this.new_location.code,
          remarks: this.remarks,
        })
        .then((response) => {
          if (response.data) {
            this.transferPopup = false;
            const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
            this.message = "Successfully donwloaded"
            this.new_location = null;
            this.remarks = '';
            this.successPopup = true;
          } else {
            this.number = 0;
            this.$toast.error("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.number = 0;
          this.$toast.error(error.response.data.error);
        });
    },
    fetchLocation() {
      this.$httpSecured
        .get("/api/v1/distribution_centers/locations")
        .then((response) => {
          if (response.data) {
            this.locationList = response.data.distribution_centers
            .filter(item => item.id !== this.location)
            .map(item => ({
              ...item,
              name: `${item.code} (${item.name})`,
            }));
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    applyFilterFunc() {
      this.search_tag = "";
      const params = {
        article_ids: this.articleId_search,
        tag_numbers: this.tagId_search,
        page: this.page,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get(
          "/api/v1/transfer_inventories?distribution_center_id=" +
            this.location +
            "&disposition=" +
            this.disposition +
            "&status=" +
            this.status +
            "&disposition_type=" +
            this.dispo_type,
          { params },
        )
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.inventories;
            this.totalPages = response.data.meta.total_pages;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.showAlert("error", "Something went wrong from Network" + error);
        });

      this.filterPopUp = false;
      // call filter api
    },
     navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "",
          action:''
        });      
        this.$router.push({ name: "LotFileuploadComm" });
      },
  },
};
</script>
<style scoped>
.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}
.v-dialog:has(.filter-data) {
  justify-content: right;
  align-items: baseline;
  top: 11rem;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}
@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 298px) !important;
}
.filter_ui{
  margin-right: 15px !important;
  margin-top: 24px !important;
} 
</style>
